exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-form-item[data-v-45ac6d8e] {\n  color: #1e0080;\n  font-weight: bold;\n}\nhr[data-v-45ac6d8e] {\n  border-color: #7da0b8;\n}\n.relevant-app-title[data-v-45ac6d8e] {\n  background-color: lightgrey;\n  padding: 10px;\n  text-align: center;\n  margin-top: 20px;\n  margin-bottom: 3px;\n}\n.relevant-app-style[data-v-45ac6d8e] {\n  border: 2px solid #7da0b8;\n  padding: 3px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-45ac6d8e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/RelevantApp.vue
// module id = 8TB/
// module chunks = 1